import { render } from "./NuevaCita.vue?vue&type=template&id=1fe7f4fa&scoped=true"
import script from "./NuevaCita.vue?vue&type=script&lang=js"
export * from "./NuevaCita.vue?vue&type=script&lang=js"

import "./NuevaCita.vue?vue&type=style&index=0&id=1fe7f4fa&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe7f4fa"]])

export default __exports__